module.exports = __webpack_public_path__ + "static/media/female-pilot_1f469-200d-2708-fe0f.09ddb44a.png";